import { render } from "./NotificationTile.vue?vue&type=template&id=741041fd"
import script from "./NotificationTile.vue?vue&type=script&lang=js"
export * from "./NotificationTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__